/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Welcome_Email_EnabledInputs */

const en_admin_settings_fields_welcome_email_enabled = /** @type {(inputs: Admin_Settings_Fields_Welcome_Email_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send welcome email on sign up`)
};

/**
* | output |
* | --- |
* | "Send welcome email on sign up" |
*
* @param {Admin_Settings_Fields_Welcome_Email_EnabledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_welcome_email_enabled = /** @type {((inputs?: Admin_Settings_Fields_Welcome_Email_EnabledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Welcome_Email_EnabledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_welcome_email_enabled(inputs)
});
export { admin_settings_fields_welcome_email_enabled as "admin.settings.fields.welcome_email_enabled" }